// extracted by mini-css-extract-plugin
export var col = "earn-module--col--ab146";
export var earn = "earn-module--earn--f5331";